<template>
  <div :class="$style['info-icon-field']">
    <slot></slot>
    <span ref="optionalIcon" :class="$style['info-icon-field__icon-wrapper']">
      <MoreInfo v-bind="$attrs" v-on="$listeners">
        <template v-slot:abbr="{ showLearnMore, content }">
          <slot name="abbr">
            <template v-if="!showLearnMore && content === '' && abbrSections.length > 0">
              <mds-section
                v-for="(section, index) in abbrSections"
                :key="index"
                border="none"
                bold
                :size="6"
                :title="section.title"
              >
                <!-- eslint-disable-next-line vue/no-v-html -->
                <p v-html="sanitizedHtml(section.content)"></p>
              </mds-section>
            </template>
          </slot>
        </template>
        <template v-slot:more="{ showLearnMore, abbrContent }">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <p :class="$style['more-info__abbr']" v-html="abbrContent"></p>
          <slot name="more">
            <template v-if="showLearnMore">
              <mds-section
                v-for="(section, index) in detailedSections"
                :key="index"
                border="none"
                bold
                :size="6"
                :title="section.title"
              >
                <!-- eslint-disable-next-line vue/no-v-html -->
                <p v-html="sanitizedHtml(section.content)"></p>
              </mds-section>
            </template>
          </slot>
        </template>
      </MoreInfo>
    </span>
  </div>
</template>
<script>
import MdsSection from '@mds/section';
import MoreInfo from './MoreInfo';
import SanitizeMixin from '../mixins/sanitizeMixin';

export default {
  name: 'info-icon-field',
  components: {
    MoreInfo,
    MdsSection,
  },
  mixins: [SanitizeMixin],
  inheritAttrs: false,
  props: {
    abbrSections: {
      type: Array,
      default: () => [],
    },
    detailedSections: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.relocatedIcon();
  },
  updated() {
    this.relocatedIcon();
  },
  methods: {
    relocatedIcon() {
      this.$nextTick(() => {
        const fieldsetLegend = this.$el.querySelector('fieldset legend:first-child');
        const labelEl = this.$el.querySelector('label div:first-child');
        if (fieldsetLegend) {
          fieldsetLegend.appendChild(this.$refs.optionalIcon);
        } else if (labelEl) {
          labelEl.appendChild(this.$refs.optionalIcon);
        }
      });
    },
  },
};
</script>

<style lang="scss" module>
@import '~@mds/constants';
.info-icon-field {
  margin-bottom: $mds-space-2-and-a-half-x;
  fieldset legend:first-child,
  label:first-child > div:first-child {
    display: flex;
    align-items: center;
  }
  &__icon-wrapper {
    display: inline-flex;
  }

  .mds-icon {
    z-index: 1;
  }
}
.more-info__abbr {
  margin: 0 0 $mds-space-2-x;
}
</style>
